import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '../layouts/AppLayout'

import { users } from './usuario'
import { settings } from './configuracion'
import { grabar } from './grabar'
import { informes } from './informe'
import { consultar } from './consultar'
import { indicadores } from './indicadores'

const _import = require('./_import_' + process.env.NODE_ENV) // Define una función _import que se utiliza para importar componentes de manera dinámica.

Vue.use(Router)

const routes = [
  {
    path: '/login',
    component: _import('login/index'),
    hidden: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/recovery',
    component: _import('recovery/index'),
    hidden: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/r/:e',
    component: _import('recovery/changepass'),
    hidden: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/empresa',
    component: _import('empresa/index'),
    hidden: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/authredirect',
    component: _import('login/authredirect'),
    hidden: true
  },
  {
    path: '/',
    component: AppLayout,
    redirect: 'dashboard',
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/admin/index'),
    meta: {
      layout: AppLayout,
      requiresAuth: true,
      breadcrumb: [
        {
          text: 'dashboard',
          to: { name: 'dashboard' },
          active: true
        }
      ]
    }
  },
  grabar,
  settings,
  users,
  consultar,
  informes,
  indicadores,
  {
    path: '/401',
    component: _import('errorPage/401'),
    hidden: true,
    meta: { requiresAuth: false }
  },
  {
    path: '*',
    component: _import('errorPage/404'),
    hidden: true,
    meta: { requiresAuth: false }
  }
]

const newrouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active'
})

newrouter.beforeEach((to, from, next) => {
  let isAuthenticated = false
  const user = localStorage.getItem('token')
  if (user) {
    isAuthenticated = true
  }
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } /* else if (
    requiresAuth &&
    isAuthenticated &&
    !isRouteAllowed(to.path, user.menu)
  ) {
    next('/unauthorized')
  } */ else {
    //if (to.name === 'grabar.index') {
    //  const arme_tipo1 = to.params.arme_tipo
    //  const arme_id1 = to.params.arme_id
    //  if (arme_tipo1) {
    //    localStorage.setItem('grabar_arme_tipo', arme_tipo1)
    //  }
    //  if (arme_id1) {
    //    localStorage.setItem('grabar_arme_id', arme_id1)
    //  }
    //}
    //if (to.name === 'grabar.ordendetrabajo.index') {
    //  const arme_tipo3 = to.params.arme_tipo
    //  const arme_id3 = to.params.arme_id
    //  if (arme_tipo3) {
    //    localStorage.setItem('grabar_ordentrabajo_arme_tipo', arme_tipo3)
    //  }
    //  if (arme_id3) {
    //    localStorage.setItem('grabar_ordentrabajo_arme_id', arme_id3)
    //  }
    //}
    //if (to.name === 'informes.index') {
    //  const arme_tipo1 = to.params.arme_tipo
    //  const arme_id1 = to.params.arme_id
    //  if (arme_tipo1) {
    //    localStorage.setItem('informes_arme_tipo', arme_tipo1)
    //  }
    //  if (arme_id1) {
    //    localStorage.setItem('informes_arme_id', arme_id1)
    //  }
    //}
    next()
  }
})

export default newrouter
